<template>
  <NuxtLayout name="search-basic-layout">
    <div class="overflow-y-hidden">
      <SearchBarWrapper></SearchBarWrapper>
      <SpaceBannerWrapper></SpaceBannerWrapper>
      <!--      <div class="h-[40px]"></div>
            <SpaceTypeListWrapper></SpaceTypeListWrapper>-->
      <SpaceListDisplayWrapper class="py-2 my-[16px] pc:my-[32px]" :title="$t('sub_title.trend_space')"
        :sub-title="$t('sub_title.trend_space_description')" :iconName="'hot'" :space-card-list="trendSpaceList">
      </SpaceListDisplayWrapper>

      <SpaceListDisplayWrapper class="my-[16px] pc:my-[32px]" :title="$t('sub_title.new_space')"
        :sub-title="$t('sub_title.new_space_description')" :iconName="'new'" :space-card-list="newSpaceList"
        :is-more="true" :more-search-param="newSpaceListQueryData"></SpaceListDisplayWrapper>

      <SpaceListDisplayWrapper v-if="like268SpaceList.length > 0" class="my-[16px] pc:my-[32px]" :title="'萊客共享空間'"
        :sub-title="'台北車站場地租借'" :iconName="'hot'" :space-card-list="like268SpaceList" :is-more="true"
        :more-search-param="like268SpaceListQueryData"></SpaceListDisplayWrapper>

      <!-- [移除付費功能] 註解掉日富空間廠商專區
      <SpaceListDisplayWrapper v-if="richerDaySpaceList.length > 0" class="my-[16px] pc:my-[32px]" :title="'日富空間'"
        :sub-title="'台北車站場地租借'" :iconName="'hot'" :space-card-list="richerDaySpaceList" :is-more="true"
        :more-search-param="richerDaySpaceListQueryData"></SpaceListDisplayWrapper>
      -->

      <UsageSearchWrapper class="mt-[16px] mb-[16px] pc:mt-[32px] pc:mb-[32px]"></UsageSearchWrapper>
      <hr class="mx-auto pc:w-[calc(1366px-140px)]">

      <LocationSearchWrapper class="mt-[16px] mb-[16px] pc:mt-[32px] pc:mb-[32px]"></LocationSearchWrapper>
      <hr class="mx-auto pc:w-[calc(1366px-140px)]">

      <OurFeaturesWrapper></OurFeaturesWrapper>
      <HowToReserveWrapper></HowToReserveWrapper>
      <!-- seo 文字-->
      <section class="seo-section  mt-10">
        <h2 class="seo-h2">空間便利店－場地租借類型</h2>
        <p id="edit" class="seo-p">
          空間便利店提供多樣化的場地租借選擇，無論是
          <a href="https://www.onestep.place/blog/photo-studio" target="_blank" rel="noopener"
            class="underline text-osn-dark-grey-00 hover:text-osn-black-00">攝影棚</a>、
          <a href="https://www.onestep.place/list/meeting-room" target="_blank" rel="noopener"
            class="underline text-osn-dark-grey-00 hover:text-osn-black-00">會議室</a>、講座，或是其它活動場地
          <a href="https://www.onestep.place/blog/space-rental" target="_blank" rel="noopener"
            class="underline text-osn-dark-grey-00 hover:text-osn-black-00">空間租借</a>
          需求，都能在這裡找到適合的場地
        </p>
      </section>
      <!-- seo 文字-->
      <section class="seo-section-xs mt-10">
        <h2 class="seo-h2">場地租借空間怎麼選？場租多少？推薦空間與費用一覽</h2>
        <p class="seo-p">
          想辦活動卻不知道如何挑選？空間大小是關鍵！<br>
          下方我們整理了場地租借的選擇重點，並提供租借費用與方案，助您輕鬆找到理想場地。
        </p>

        <div class="seo-card-wrap">
          <div class="seo-card pc:mr-3 mobile:mb-3">
            <div class="">
              <h3 class="seo-h3">小場地租借</h3>
              <ul>
                <li>
                  <svg-icon class="mr-2" name="people_capacity" size="16" />
                  容納人數：1 至 20 人
                </li>
                <li>
                  <svg-icon class="mr-2" name="suggested_activity" size="16" />
                  建議活動：小型會議、商務洽談、辦公空間、課程講座、私人聚會、派對等。
                </li>
              </ul>
            </div>
            <img class="seo-img" src="/seo/site-sm.png" alt="小場地租借" loading="lazy" />
          </div>
          <div class="seo-card">
            <div>
              <h3 class="seo-h3">中、大場地租借</h3>
              <ul>
                <li>
                  <svg-icon class="mr-2" name="people_capacity" size="16" />
                  容納人數：21 至 100 人以上
                </li>
                <li>
                  <svg-icon class="mr-2" name="suggested_activity" size="16" />
                  建議活動：大型會議、研討會、產品發表會、展覽、婚宴等。
                </li>
              </ul>
            </div>
            <img class="seo-img" src="/seo/site-xl.png" alt="中、大場地租借" loading="lazy" />
          </div>
        </div>


      </section>
      <BlogArticleWrapper></BlogArticleWrapper>
      <LazyFooterLoginWrapper></LazyFooterLoginWrapper>
      <FloatingHelp></FloatingHelp>
    </div>
  </NuxtLayout>
</template>
<script setup>
definePageMeta(
  { title: '空間便利店' }
)

import SearchBarWrapper from "@/components/SearchIndex/SearchBarWrapper/SearchBarWrapper.vue";
// import LazyFooterLoginWrapper from "@/components/SearchIndex/FooterLogin/FooterLoginWrapper.vue"
const LazyFooterLoginWrapper = defineAsyncComponent(() =>
  import('@/components/SearchIndex/FooterLogin/FooterLoginWrapper.vue')
);
import LocationSearchWrapper from "@/components/SearchIndex/FastSearch/LocationSearchWrapper.vue"
import UsageSearchWrapper from "@/components/SearchIndex/FastSearch/UsageSearchWrapper.vue"
import SpaceListDisplayWrapper from "@/components/SearchIndex/SearchSpaceCard/SpaceListDisplayWrapper.vue"
import OurFeaturesWrapper from "../components/SearchIndex/OurFeatures/OurFeaturesWrapper.vue";
import HowToReserveWrapper from "../components/SearchIndex/HowToReserve/HowToReserveWrapper.vue";
// import SpaceTypeListWrapper from "@/components/SearchIndex/SpaceTypeList/SpaceTypeListWrapper.vue";
import SpaceBannerWrapper from "@/components/SearchIndex/SpaceBanner/SpaceBannerWrapper.vue";
import BlogArticleWrapper from "@/components/SearchIndex/BlogArticle/BlogArticleWrapper.vue";
import FloatingHelp from "@/components/FloatingHelp.vue";

import { getElementByDate } from "@/utils/parseTool.js"
import { useSettingStore } from "@/stores/setting";
import {
  newSpaceListQueryData,
  trendSpaceListQueryDataList,
  richerDaySpaceListQueryData,
  trendSpaceListQueryDataList2,
  like268SpaceListQueryData,
  richerDaySpaceIdList,
  like268SpaceIdList
} from "@/config/testCode.js"
import { useSearch } from "@/composables/useSearch";

import { getMainPageSpaceList, getMainPageSpaceId } from "@/api/space";


const settingStore = useSettingStore()
const { handleSearch } = useSearch()

// 使用 useAsyncData 來抓取 newSpaceListQueryData 資料
/*const {data: newSpaceListData} = await useAsyncData(
    'newSpaceListQueryData',
    () => handleSearch(newSpaceListQueryData));*/
// const newSpaceList = ref([]); // 新的空間 要配合onMounted 裡面被註解的

/*const newSpaceList = computed(() => {
  return newSpaceListData.value ?
      newSpaceListData.value.list
          .sort(() => Math.random() - 0.5)
          .slice(0, 4) :
      [];
});*/


const { data: mainPageSpaceIdData } = await useAsyncData(
  'mainPageSpaceIdData',
  () => getMainPageSpaceId());


// 新的首頁api query
const mainPageSpaceListQuery = {
  new_space: true,
  space_blocks: [
    mainPageSpaceIdData.value?.trend_spaces ?? [], // 熱門場地：改由管理員在 manage 指定（/api/platform/main-page-spaces）
    like268SpaceIdList,                            // 萊客共享空間：本次未改，維持原設定
    richerDaySpaceIdList                           // 日富空間：本次未改，維持原設定
  ],
}

// 新的首頁 api
const { data: mainPageSpaceListData } = await useAsyncData(
  'mainPageSpaceListData',
  () => getMainPageSpaceList(mainPageSpaceListQuery));


// 新的首頁api 最新場地
const newSpaceList = computed(() => {
  return mainPageSpaceListData.value?.new_space || [];
});


// 熱門空間
/*const {data: trendSpaceListData} = await useAsyncData(
    'trendSpaceListQueryDataList',
    async () => {
      // 使用 Promise.all 並行呼叫每個查詢
      const responses = await Promise.all(
          trendSpaceListQueryDataList2.map(query => handleSearch(query))
      );

      // 提取每個回傳結果的第一筆資料
      return responses
          .filter(spaceList => spaceList.total > 0)
          .map(response => response.list?.[0] || {});
    }
);
const trendSpaceList = computed(() => {
  return trendSpaceListData.value ? trendSpaceListData.value : [];
});*/

// 首頁新api 熱門場地
const trendSpaceList = computed(() => {

  // return trendSpaceListData.value || [];
  return mainPageSpaceListData.value?.space_blocks?.[0] ?? []
});


// 萊客共享空間
/*const {data: like268SpaceListData} = await useAsyncData(
    'like268SpaceListQueryDataList',
    () => handleSearch(like268SpaceListQueryData));*/

// 首頁新api 萊客共享空間
const like268SpaceList = computed(() => {

  // return like268SpaceListData.value ? like268SpaceListData.value.list.slice(0, 4) : [];

  return mainPageSpaceListData.value?.space_blocks?.[1] || [];
});


// 日富空間資料
/*const {data: richerDaySpaceListData} = await useAsyncData(
    'richerDaySpaceListQueryDataList',
    () => handleSearch(richerDaySpaceListQueryData));*/

// // 首頁新api 日富空間資料
const richerDaySpaceList = computed(() => {

  // return richerDaySpaceListData.value ? richerDaySpaceListData.value.list.slice(0, 4) : [];
  // console.log('mainPageSpaceListData.value.space_blocks[1] = ',mainPageSpaceListData.value.space_blocks[1]);
  return mainPageSpaceListData.value?.space_blocks?.[2] || [];
});

// 如果資料非響應式，可以使用 useServerSeoMeta()，在 server 端預先處理完 meta 相關邏輯，提升網頁效能
const seoMeta = {
  title: '全台場地租借推薦｜空間便利店，你的活動場地租借首選',
  description: '全台大、中、小場地租借推薦空間便利店！多元活動場地租借空間滿足各式派對、聚會、辦公室會議、攝影棚錄影錄音等租借需求。平台提供便利快速的租借系統，且出租空間坪數、價格資訊一目瞭然，讓您輕鬆找到理想場地！',
  keywords: '場地租借、會議室、攝影棚、廚房租借、活動空間、餐廳包廂、聚會場地，都可線上預約',
  ogTitle: '空間便利店｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約',
  ogSiteName: '空間便利店',
  ogDescription: '空間便利店是一個線上的場地租借平台！我們提供線上預約，省去聯絡，方便又順利。活動空間、會議室，攝影棚、餐廳包廂、聚會場地都可預約',
  ogImage: 'https://pic.onestep.place/images/onestep-og.png',
  ogImageAlt: '空間便利店｜方便順利的場地租借平台。時租日租場地，活動聚會場地，商務會議線上預約',
  ogUrl: 'https://www.onestep.place',
  ogType: 'website',
};

useSeoMeta(seoMeta);

onMounted(() => {
  settingStore.updateHomeRouter('/')
  /*  if (newSpaceListData.value && Array.isArray(newSpaceListData.value.list)) {
      newSpaceList.value = [...newSpaceListData.value.list]
          .sort(() => Math.random() - 0.5)
          .slice(0, 4);
    }*/
})

useHead({
  script: [
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "空間便利店",
        "url": "https://www.onestep.place/",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://www.onestep.place/search-result?_keyword={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      })
    },
    {
      type: 'application/ld+json',
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "場地租借到空間便利店",
        "image": "https://www.onestep.place/_nuxt/osn-zh-horizon.BkKNCBaC.png",
        "url": "https://www.onestep.place/",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "台北市大安區忠孝東路四段221號",
          "addressLocality": "台北市",
          "addressCountry": "TW"
        },
        "telephone": "+886-2-6623-6940"
      })
    }
  ]
})


</script>
<style scoped lang="scss">
.seo-section {
  @apply pc:mx-auto pc:px-[140px] pc:max-w-[1366px] px-4 pc:text-[20px];

  .seo-h2 {
    @apply font-black pc:text-[24px] mobile:text-[20px];
  }

  .seo-p {
    @apply mt-2 text-osn-grey-01 font-normal pc:text-[16px] mobile:text-[14px];
  }
}

.seo-section-xs {
  @apply pc:mx-auto pc:px-[140px] pc:max-w-[1366px] px-4 bg-osn-grey-04 py-[50px];

  .seo-h2 {
    @apply font-black pc:text-[24px] mobile:text-[20px] mobile:leading-6;
  }

  .seo-p {
    @apply mt-2 text-osn-grey-01 font-normal pc:text-[16px] mobile:text-[14px] mobile:leading-5;
  }

  .seo-h3 {
    @apply mt-4 font-bold text-[20px];
  }

  .seo-card-wrap {
    @apply mt-5 flex mobile:flex-wrap;

    .seo-card {
      @apply pc:w-[537px] mobile:w-full flex justify-between pc:pl-[30px] mobile:pl-[12px] bg-osn-white-00 rounded-[20px];

      .seo-h3 {
        @apply pc:mt-[30px] mobile:mt-[16px] pc:mb-[16px] mobile:mb-[10px] font-bold pc:text-[18px] mobile:text-[15px] text-osn-dark-grey-00;
      }

      ul {
        @apply mt-2 pc:mr-[25px] mobile:mr-[12px] pc:mb-[30px];

        li {
          @apply flex pc:text-[15px] mobile:text-[12px] mobile:mb-[4px];

          svg {
            @apply pc:mt-1 flex-shrink-0;
          }

        }
      }

      /* 確保圖片在 PC 和手機上等比例縮放 */
      .seo-img {
        @apply flex-shrink-0 pc:w-[184px] pc:h-[161px] aspect-[184/161] pc:max-w-[184px] mobile:w-[130px] mobile:h-[128px];
      }
    }
  }
}
</style>
